import * as React from 'react';

export default class Footer extends React.PureComponent<{}> {

    public render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                <path d="M15.224 34.6224V29.5262C15.224 28.2253 16.2863 27.1707 17.5967 27.1707H22.387C23.0163 27.1707 23.6198 27.4188 24.0648 27.8606C24.5098 28.3023 24.7598 28.9015 24.7598 29.5262V34.6224C24.7558 35.1632 24.9695 35.6833 25.3533 36.0671C25.7371 36.451 26.2594 36.6668 26.8042 36.6668H30.0724C31.5987 36.6708 33.0639 36.0716 34.1446 35.0015C35.2253 33.9315 35.8327 32.4785 35.8327 30.9632V16.4449C35.8327 15.2209 35.2861 14.0599 34.3404 13.2746L23.2227 4.45994C21.2888 2.91443 18.5179 2.96433 16.6417 4.57846L5.7777 13.2746C4.78725 14.0368 4.19527 15.2012 4.16602 16.4449V30.9484C4.16602 34.1066 6.74498 36.6668 9.9263 36.6668H13.1198C14.2514 36.6668 15.171 35.7605 15.1792 34.6372L15.224 34.6224Z"
                    fill="#2C3B48" />
            </svg>
        );
    }
}
